import { Component, computed, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { ToastContainerComponent } from '@/app/components/toast/toast.component';
import { SpinnerComponent } from '@/app/components/spinner/spinner.component';
import { filter, map } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { getPath, PathUnit } from '@/app/consts/path.const';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    ToastContainerComponent,
    SpinnerComponent,
  ],
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent {

  private router = inject(Router);

  currentUrl = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map(event => {
        return event.urlAfterRedirects;
      })
    ),
    { initialValue: this.router.url || '' } // 改为 router.url 避免初始为空导致 computed 误判
  );

  ngOnInit() {
    this.hideBreadcrumbs();
    this.hideSideBar();
  }

  hideSideBar = computed(() => {
    const pathForbiddenSideBar = [
      `/${getPath(PathUnit.LandingPage)}`, 
    ];
    const normalize = (u: string) => (u || '').split('?')[0].split('#')[0];
    const cur = normalize(this.currentUrl() || this.router.url || '');
    return pathForbiddenSideBar.some(url => cur.startsWith(url)); // 使用 startsWith 减少部分匹配带来的误判
  });

  hideBreadcrumbs = computed(() => {
    const pathForbiddenBreadcrumbs = [
      `/${getPath(PathUnit.LandingPage)}`, 
      `/${getPath(PathUnit.RequestAccess)}`,
      `/${getPath(PathUnit.NotificationsMgmt)}`,
    ];
    const normalize = (u: string) => (u || '').split('?')[0].split('#')[0];
    const cur = normalize(this.currentUrl() || this.router.url || '');

    // software-center/upload, do not block upload breadcrumbs, so should not use startsWith here
    // return pathForbiddenBreadcrumbs.some(url => cur.startsWith(url));
    return pathForbiddenBreadcrumbs.some(url => cur === url);
  });

}